let ControlPosition = require('./control-position');
let MapTypeControlStyle = require('./map-type-control-style');

module.exports = {
  ControlPosition,
  MapTypeControlStyle
};
